import { MenuItem } from "@mui/material";
import { Formik } from "formik";
import FormikActions from "../../../../commons/formik/FormikActions";
import FormikDatePicker from "../../../../commons/formik/FormikDatePicker";
import FormikSelect from "../../../../commons/formik/FormikSelect";
import FormikTextField from "../../../../commons/formik/FormikTextField";
import { StyledABMNomina } from "../../../../styled/Personal";
import {
    datosParticularesValidation,
    validateRequiredFields,
} from "../validation/formValidation";

const DatosParticularesForm = ({ handleSubmit, model, fields }) => {

  const disabled = !fields;

  return (
    <>
      <Formik
        initialValues={model}
        onSubmit={handleSubmit}
        validationSchema={() => datosParticularesValidation()}
        validate={(values) => validateRequiredFields(values, fields)}
      >
        {({ errors, touched, values }) => (
          <StyledABMNomina.FormContainer>
            <StyledABMNomina.GridContainer container spacing={3}>
              <StyledABMNomina.InputContainer item xs={4}>
                <FormikTextField
                  fullWidth
                  id="apellido"
                  name="apellido"
                  type="text"
                  label={`Apellido ${fields.apellido.obligatorio ? "*" : ""}`}
                  disabled={disabled}
                />
              </StyledABMNomina.InputContainer>
              <StyledABMNomina.InputContainer item xs={4}>
                <FormikTextField
                  fullWidth
                  id="nombres"
                  name="nombres"
                  type="text"
                  label={`Nombres ${fields.nombres.obligatorio ? "*" : ""}`}
                  disabled={disabled}
                />
              </StyledABMNomina.InputContainer>
              <StyledABMNomina.InputContainer item xs={4}>
                <FormikSelect
                  fullWidth
                  name="tipoDocumento"
                  label={`Tipo documento ${
                    fields.tipoDocumento.obligatorio ? "*" : ""
                  }`}
                  variant="standard"
                  disabled={disabled}
                >
                  {fields?.tipoDocumento.opciones.map(({ id, nombre }) => {
                    return (
                      <MenuItem value={id} key={id}>
                        {nombre}
                      </MenuItem>
                    );
                  })}
                </FormikSelect>
              </StyledABMNomina.InputContainer>
              <StyledABMNomina.InputContainer item xs={4}>
                <FormikTextField
                  fullWidth
                  id="nroDocumento"
                  name="nroDocumento"
                  type="text"
                  label={`Nro documento ${
                    fields.nroDocumento.obligatorio ? "*" : ""
                  }`}
                  disabled={disabled}
                />
              </StyledABMNomina.InputContainer>
              <StyledABMNomina.InputContainer item xs={4}>
                <FormikTextField
                  fullWidth
                  id="nacionalidad"
                  name="nacionalidad"
                  label={`Nacionalidad ${
                    fields.nacionalidad.obligatorio ? "*" : ""
                  }`}
                  type="text"
                  disabled={disabled}
                />
              </StyledABMNomina.InputContainer>

              <StyledABMNomina.InputContainer item xs={4}>
                <FormikDatePicker
                  id="fechaNacimiento"
                  name="fechaNacimiento"
                  type="text"
                  label={`Fecha de nacimiento ${
                    fields.fechaNacimiento.obligatorio ? "*" : ""
                  }`}
                  disableFuture
                  fullWidth
                  disabled={disabled}
                />
              </StyledABMNomina.InputContainer>
              <StyledABMNomina.InputContainer item xs={4}>
                <FormikSelect
                  fullWidth
                  name="genero"
                  label={`Género ${fields.genero.obligatorio ? "*" : ""}`}
                  variant="standard"
                  disabled={disabled}
                >
                  {fields?.genero.opciones.map(({ id, nombre }) => {
                    return (
                      <MenuItem value={id} key={id}>
                        {nombre}
                      </MenuItem>
                    );
                  })}
                </FormikSelect>
              </StyledABMNomina.InputContainer>
              <StyledABMNomina.InputContainer item xs={4}>
                <FormikSelect
                  fullWidth
                  name="estadoCivil"
                  label={`Estado civil ${
                    fields.estadoCivil.obligatorio ? "*" : ""
                  }`}
                  variant="standard"
                  disabled={disabled}
                >
                  {fields?.estadoCivil.opciones.map(({ id, nombre }) => {
                    return (
                      <MenuItem value={id} key={id}>
                        {nombre}
                      </MenuItem>
                    );
                  })}
                </FormikSelect>
              </StyledABMNomina.InputContainer>
              <StyledABMNomina.InputContainer item xs={4}>
                <FormikTextField
                  fullWidth
                  id="telefono"
                  name="telefono"
                  type="text"
                  label={`Celular ${fields.telefono.obligatorio ? "*" : ""}`}
                  disabled={disabled}
                />
              </StyledABMNomina.InputContainer>
              <StyledABMNomina.InputContainer item xs={4}>
                <FormikTextField
                  fullWidth
                  id="mail"
                  name="mail"
                  type="text"
                  label={`Mail ${fields.mail.obligatorio ? "*" : ""}`}
                  disabled={disabled}
                />
              </StyledABMNomina.InputContainer>
            </StyledABMNomina.GridContainer>
            <StyledABMNomina.ButtonContainer>
              <FormikActions submit="Siguiente" />
            </StyledABMNomina.ButtonContainer>
          </StyledABMNomina.FormContainer>
        )}
      </Formik>
    </>
  );
};

export default DatosParticularesForm;
